// =====================================================
// CONFIGURAÇÃO DE URLs - USA VARIÁVEIS DE AMBIENTE
// Arquivo: FillSign.Website/src/lib/config.ts
// =====================================================

// Ambiente atual
export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT || 'development';

// URL do App (para login/register)
export const APP_URL = import.meta.env.VITE_APP_URL || "http://localhost:5174";

// URL da API
export const API_URL = import.meta.env.VITE_API_URL || "http://localhost:5095";

// URL do Website (este site)
export const WEBSITE_URL = import.meta.env.VITE_WEBSITE_URL || "http://localhost:5173";

// URL do vídeo demo (YouTube)
export const DEMO_VIDEO_URL = import.meta.env.VITE_DEMO_VIDEO_URL || "https://www.youtube.com/embed/dQw4w9WgXcQ";

// Helper function para construir URLs da API
export function getApiUrl(path: string): string {
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${API_URL}${cleanPath}`;
}

// Verificar se é ambiente de teste
export function isTestEnvironment(): boolean {
  const env = ENVIRONMENT.toLowerCase();
  return env === 'development' || env === 'dev' || env === 'staging' || env === 'uat';
}

// Rotas do App
export const APP_ROUTES = {
  login: `${APP_URL}/login`,
  register: `${APP_URL}/register`,
  dashboard: `${APP_URL}/dashboard`,
};

// Rotas do Website
export const WEBSITE_ROUTES = {
  home: "/",
  pricing: "/pricing",
  help: "/help",
  enterpriseContact: "/enterprise-contact",
  terms: "/terms",
  privacy: "/privacy",
  license: "/license",
  dynamics365: "/dynamics365",
  apiDocs: "/api-docs",
  validate: "/validar",
};

// Debug: Log das configurações (apenas em dev)
if (ENVIRONMENT === 'development') {
  console.log('[Config] Environment:', ENVIRONMENT);
  console.log('[Config] API_URL:', API_URL);
  console.log('[Config] APP_URL:', APP_URL);
  console.log('[Config] WEBSITE_URL:', WEBSITE_URL);
}
